import {Component, Input, OnInit} from '@angular/core';
import StyleFormatter from '../../../utils/style-formatter';
import {MatDialog} from '@angular/material/dialog';
import {
  LdapServerCertificateViewComponent
} from '../ldap-server-certificate-view/ldap-server-certificate-view.component';

@Component({
  selector: 'servers-summary',
  templateUrl: './servers-summary.component.html',
  styleUrls: ['./servers-summary.component.scss']
})
export class ServersSummaryComponent implements OnInit {

  styleFormatter;

  @Input() selection: any;
  @Input() normalizationGroups: any;

  constructor( public dialog: MatDialog) {
    this.styleFormatter = StyleFormatter;
  }

  ngOnInit(): void {
  }

  getNormalizationGroupName(id): string {
    const group = this.normalizationGroups.find((groupItem) => {
      return groupItem.id === id;
    });
    if (group) {
      return group.groupName;
    }
  }

  openCertificateView(): void {
    this.dialog.open(LdapServerCertificateViewComponent, {data: this.selection, width: '650px', height: '610px'});
  }
}
